"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.gtmService = void 0;

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseKey"));

var _browserHelpers = require("@phx-husky/browser-helpers");

var _model = require("./model");

const defaultEventDelayMs = 300;
const defaultMinimumViewTime = 500;
const productListName = 'products';
const promotion = 'retailer_link_click';

var _eventDelayMs = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("eventDelayMs");

var _tagmanagerPluginRouteDelay = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("tagmanagerPluginRouteDelay");

var _minimumViewTime = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("minimumViewTime");

var _currentPageEvents = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("currentPageEvents");

var _emitEvent = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("emitEvent");

var _emitEventDelayed = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("emitEventDelayed");

var _convertProductsToDL = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("convertProductsToDL");

class GTMService {
  constructor(eventDelayMs, minimumViewTime) {
    Object.defineProperty(this, _convertProductsToDL, {
      value: _convertProductsToDL2
    });
    Object.defineProperty(this, _emitEventDelayed, {
      value: _emitEventDelayed2
    });
    Object.defineProperty(this, _emitEvent, {
      value: _emitEvent2
    });
    Object.defineProperty(this, _eventDelayMs, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _tagmanagerPluginRouteDelay, {
      writable: true,
      value: 50
    });
    Object.defineProperty(this, _minimumViewTime, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _currentPageEvents, {
      writable: true,
      value: []
    });
    (0, _classPrivateFieldLooseBase2.default)(this, _eventDelayMs)[_eventDelayMs] = (parseInt(eventDelayMs, 10) || defaultEventDelayMs) + (0, _classPrivateFieldLooseBase2.default)(this, _tagmanagerPluginRouteDelay)[_tagmanagerPluginRouteDelay];
    (0, _classPrivateFieldLooseBase2.default)(this, _minimumViewTime)[_minimumViewTime] = parseInt(minimumViewTime, 10) || defaultMinimumViewTime;
  }

  get minimumViewTime() {
    return (0, _classPrivateFieldLooseBase2.default)(this, _minimumViewTime)[_minimumViewTime];
  }

  emitRouteChange() {
    (0, _classPrivateFieldLooseBase2.default)(this, _currentPageEvents)[_currentPageEvents] = [];
    const event = {
      event: _model.EventName.RouteChange
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEvent)[_emitEvent](event);
  }

  emitPageView(pageTemplate) {
    const event = {
      page_template: pageTemplate,
      promotion_name: null
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEvent)[_emitEvent](event);
  }

  emitHeaderMenuClick(elementText) {
    const clickEvent = {
      event: _model.EventName.HeaderMenuClick,
      click_text: elementText
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEvent)[_emitEvent](clickEvent);
  }

  emitRetailerClick(retailerName, retailerUrl) {
    const clickEvent = {
      event: _model.EventName.RetailerClick,
      retailer_name: retailerName,
      link_url: retailerUrl
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEvent)[_emitEvent](clickEvent);
  }

  emitViewSearchResults(searchTerm) {
    const clickEvent = {
      event: _model.EventName.ViewSearchResults,
      search_term: searchTerm.toLocaleLowerCase()
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEventDelayed)[_emitEventDelayed](clickEvent, 700);
  }

  emitFormSubmit(formName) {
    const submitEvent = {
      event: _model.EventName.GenerateLead,
      form_name: formName
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEvent)[_emitEvent](submitEvent);
  }

  emitViewElement(componentName) {
    const elementSeen = (0, _classPrivateFieldLooseBase2.default)(this, _currentPageEvents)[_currentPageEvents].some(event => 'event' in event && event.event === _model.EventName.ViewElement && event.element_name === componentName);

    if (elementSeen) return;
    const viewElementEvent = {
      event: _model.EventName.ViewElement,
      element_name: componentName
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEventDelayed)[_emitEventDelayed](viewElementEvent);
  }

  emitViewItem(item, pageTemplate, lastProductIndex) {
    const viewItemEvent = {
      event: _model.EventName.ViewItem,
      page_template: pageTemplate,
      ecommerce: {
        items: (0, _classPrivateFieldLooseBase2.default)(this, _convertProductsToDL)[_convertProductsToDL]([item], false, {
          index: lastProductIndex || undefined
        })
      }
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEventDelayed)[_emitEventDelayed](viewItemEvent);
  }

  emitViewItemList(items, otherOptions) {
    const viewItemListEvent = {
      event: _model.EventName.ViewItemList,
      item_list_name: productListName,
      ecommerce: {
        items: (0, _classPrivateFieldLooseBase2.default)(this, _convertProductsToDL)[_convertProductsToDL](items, true, otherOptions)
      }
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEventDelayed)[_emitEventDelayed](viewItemListEvent);
  }

  emitSelectPromotion(item, retailerName, lastProductIndex) {
    const selectPromotionEvent = {
      event: _model.EventName.SelectPromotion,
      retailer_name: retailerName,
      promotion_name: promotion,
      ecommerce: {
        items: (0, _classPrivateFieldLooseBase2.default)(this, _convertProductsToDL)[_convertProductsToDL]([item], false, {
          index: lastProductIndex
        })
      }
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEventDelayed)[_emitEventDelayed](selectPromotionEvent);
  }

  emitSelectItem(item, otherOptions) {
    const selectItemEvent = {
      event: _model.EventName.SelectItem,
      item_list_name: productListName,
      ecommerce: {
        items: (0, _classPrivateFieldLooseBase2.default)(this, _convertProductsToDL)[_convertProductsToDL]([item], false, otherOptions)
      }
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEvent)[_emitEvent](selectItemEvent);
  }

  emitRetailerLinkConfirmation(retailerName, linkUrl) {
    const retailerLinkConfirmationEvent = {
      event: _model.EventName.RetailerLinkConfirmation,
      retailer_name: retailerName,
      link_url: linkUrl
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEvent)[_emitEvent](retailerLinkConfirmationEvent);
  }

  emitRetailerLinkRejection(retailerName, linkUrl) {
    const retailerLinkRejectionEvent = {
      event: _model.EventName.RetailerLinkRejection,
      retailer_name: retailerName,
      link_url: linkUrl
    };

    (0, _classPrivateFieldLooseBase2.default)(this, _emitEvent)[_emitEvent](retailerLinkRejectionEvent);
  }

}

function _emitEvent2(event) {
  if (!(0, _browserHelpers.isBrowser)()) return;

  (0, _classPrivateFieldLooseBase2.default)(this, _currentPageEvents)[_currentPageEvents].push(event);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

function _emitEventDelayed2(event, customDelayCounter) {
  return setTimeout(() => {
    (0, _classPrivateFieldLooseBase2.default)(this, _emitEvent)[_emitEvent](event);
  }, customDelayCounter || (0, _classPrivateFieldLooseBase2.default)(this, _eventDelayMs)[_eventDelayMs]);
}

function _convertProductsToDL2(items, withIndex, otherOptions) {
  (0, _classPrivateFieldLooseBase2.default)(this, _emitEvent)[_emitEvent]({
    // @ts-ignore
    ecommerce: null
  });

  return items.map((item, index) => {
    var _item$brandName;

    return {
      item_id: item === null || item === void 0 ? void 0 : item.barcodeNumber,
      item_name: (item === null || item === void 0 ? void 0 : item.productTitle) || item.title,
      item_brand: item !== null && item !== void 0 && (_item$brandName = item.brandName) !== null && _item$brandName !== void 0 && _item$brandName.length ? item.brandName[0] : null,
      item_category: item === null || item === void 0 ? void 0 : item.segmentDescription,
      item_category2: (item === null || item === void 0 ? void 0 : item.aromaScent) || undefined,
      item_variant: item === null || item === void 0 ? void 0 : item.netContentStatement,
      item_list_name: productListName,
      ...(withIndex && {
        index: index + 1
      }),
      ...(otherOptions && { ...otherOptions
      })
    };
  });
}

const gtmService = new GTMService(process.env.GATSBY_TAG_DELAY || '', process.env.GATSBY_VISIBLE_TIMEOUT || '');
exports.gtmService = gtmService;